module.exports = __webpack_public_path__ + "static/fjc@2x-d294cdc6e70f353c4cd25d47336ba7b4.png";